import { Table, Tabs } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Spinner from '../../components/Spinner';
import useFetch from '../../helpers/useFetch';

const tabConfig = ['lastMonth', 'last3Months'].map((key) => ({
  key,
  name: key.replace('last', 'Last ').replace('Month', ' Month'),
}));

const CompaniesDetailsAggregatedStatsPage = ({ trackingId }) => {
  const fetch = useFetch();
  const [key, setKey] = useState(tabConfig[0].key);
  const [stats, setStats] = useState();
  const [error, setError] = useState();
  const { accountId, domainId } = useParams();
  const { domain } = useSelector((state) => state.domain);

  useEffect(() => {
    fetch(
      `/api/admin/accounts/${accountId}/domains/${domainId}/companies/stats?id=${encodeURIComponent(trackingId)}`,
      {}
    )
      .then(async ({ stats }) => {
        setStats(stats);
      })
      .catch((error) => setError(error));
  }, [fetch, accountId, domainId, trackingId]);

  const formatCurrency = (val) => {
    if (val === null || val === undefined) {
      return val;
    }
    return val.toLocaleString(navigator.language, { style: 'currency', currency: domain.currency });
  };

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  return (
    <>
      <Tabs value={key} onChange={setKey} ta="center">
        <Tabs.List>
          {tabConfig.map(({ key: tabKey, name }) => (
            <Tabs.Tab key={tabKey} value={tabKey}>
              {name}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
      {!stats ? (
        <Spinner />
      ) : (
        <Table striped withTableBorder highlightOnHover>
          <Table.Tbody>
            <Table.Tr>
              <Table.Th>Product Views</Table.Th>
              <Table.Td>{stats[key].productViews.count.toLocaleString(navigator.language)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>Orders</Table.Th>
              <Table.Td>{stats[key].orders.count.toLocaleString(navigator.language)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>Customer Value</Table.Th>
              <Table.Td>{formatCurrency(stats[key].orders.value)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>Average Order Value</Table.Th>
              <Table.Td>
                {stats[key].orders.value === 0
                  ? 0
                  : formatCurrency(stats[key].orders.value / parseFloat(stats[key].orders.count))}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>Average Order Size</Table.Th>
              <Table.Td>
                {stats[key].orders.productCount === 0
                  ? 0
                  : (stats[key].orders.productCount / parseFloat(stats[key].orders.count)).toLocaleString(
                      navigator.language
                    )}
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      )}
    </>
  );
};

export default CompaniesDetailsAggregatedStatsPage;
